module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Domleschg_COA-b55499f7379fa8f90181f34424550d67.svg";